var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.8062,
    r: 14,
    stroke: "rgba(255,255,255,0.2)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5977 21.4897H13.2109V14.8101H16.5977V21.4897Z",
    fill: "rgba(255,255,255,0.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5156 10.2866C13.1719 10.6069 13 11.0132 13 11.5054C13 11.9976 13.1719 12.4038 13.5156 12.7241C13.8594 13.0444 14.3203 13.2046 14.8984 13.2046C15.4688 13.2046 15.9258 13.0444 16.2695 12.7241C16.6211 12.4038 16.7969 11.9976 16.7969 11.5054C16.7969 11.0132 16.6211 10.6069 16.2695 10.2866C15.9258 9.96631 15.4688 9.80615 14.8984 9.80615C14.3203 9.80615 13.8594 9.96631 13.5156 10.2866Z",
    fill: "rgba(255,255,255,0.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3d765e2d02b18d76e1c1105fc7e9786a.svg";
export { ForwardRef as ReactComponent };